<script>
export default {
  props: {
    reviewContent: {
      type: String,
      default: '',
    },
    authorImage: {
      type: String,
      default: '',
    },
    authorName: {
      type: String,
      default: '',
    },
    authorDesignation: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div
    class="group relative flex w-80 flex-col gap-5 rounded-3xl bg-gradient-to-br from-white/95 via-white/90 to-white/85 p-8 text-left text-n-slate-12 shadow-xl ring-1 ring-white/30 transition-all duration-500 ease-out hover:-translate-y-3 hover:shadow-3xl dark:from-n-solid-2/95 dark:via-n-solid-2/90 dark:to-n-solid-2/85 dark:text-n-slate-12 dark:ring-n-alpha-2"
  >
    <span
      class="pointer-events-none absolute -top-6 left-8 inline-flex h-12 w-12 items-center justify-center rounded-full bg-n-brand text-white shadow-lg ring-4 ring-white/20"
    >
      <span class="i-lucide-quote h-5 w-5" />
    </span>

    <div class="flex items-center gap-1 pt-6 text-n-brand/90">
      <span v-for="star in 5" :key="star" class="i-lucide-star h-4 w-4" />
    </div>

    <p class="text-sm leading-relaxed text-n-slate-12/90 dark:text-white/80">
      {{ reviewContent }}
    </p>

    <div class="flex items-center gap-3 text-n-slate-12">
      <div
        class="rounded-full bg-white/90 p-[0.1875rem] shadow-md ring-2 ring-white/60"
      >
        <img :src="authorImage" class="h-10 w-10 rounded-full object-cover" />
      </div>
      <div>
        <div class="text-sm font-semibold">{{ authorName }}</div>
        <div class="text-xs text-n-slate-11">{{ authorDesignation }}</div>
      </div>
    </div>
  </div>
</template>
